import { RestService } from './services/rest.service';
import { GasComponent } from './pages/gas/gas.component';
import { NewItemComponent } from './pages/new-item/new-item.component';
import { CategoryFilterPipe } from './pipes/category-filter.pipe';
import { DetailsComponent } from './pages/details/details.component';
import { ProcessingSheetComponent } from './pages/processing-sheet/processing-sheet.component';
import { ProcessingDetailsComponent } from './pages/processing-details/processing-details.component';
import { HomeComponent } from './pages/home/home.component';
import { MenuComponent } from './components/menu/menu.component';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  BUTTON_STYLE_CONFIGURATION,
  CommonUiModule,
  DATE_FORMAT_CONFIGURATION,
  IButtonStyleConfiguration,
  IDateFormatConfiguration,
  MultiTranslateHttpLoaderFactory,
} from '@bcl/common-ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material/material.module';
import {
  FileStoreModule,
  FILE_STORE_CONFIGURATION,
  IFileStoreConfiguration,
} from '@bcl/file-store';
import {
  HttpBackend,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { CommonModule, Location } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RootComponent } from './root.component';
import { UserInfoComponent } from './components/user-info/user-info.component';
import { HttpRequestInterceptor } from './http-request-interceptor';
import { environment } from '../environments';
import { IonicStorageModule } from '@ionic/storage-angular';
import {
  UsersManagementModule,
  CurrentUserService,
} from '@ews/users-management';
import { ConfigurationModule } from '@bcl/configuration';
import { DesignSystemModule } from '@bcl/design-system';
import { LoginModule } from './login';
import { AuthService } from './services/auth.service';
// eslint-disable-next-line max-len
import { WeightRegistrationDialogComponent } from './pages/processing-details/weight-registration-dialog/weight-registration-dialog.component';
import { WasteRegistrationComponent } from './pages/waste-registration/waste-registration.component';
import { QuestionnairePage } from './pages/questionnaire/questionnaire.page';
import { QuestionCategoryComponent } from './pages/questionnaire/components/question-category/question-category.component';
import { QuestionComponent } from './pages/questionnaire/components/question/question.component';
import { QuestionCommentsPage } from './pages/question-comments/question-comments.component';
import { QuestionPhotosPage } from './pages/question-photos/question-photos.page';
import { ImageCropperModule } from 'ngx-image-cropper';

@NgModule({
  declarations: [
    CategoryFilterPipe,
    RootComponent,
    AppComponent,
    UserInfoComponent,
    HomeComponent,
    DetailsComponent,
    ProcessingSheetComponent,
    ProcessingDetailsComponent,
    NewItemComponent,
    GasComponent,
    MenuComponent,
    WeightRegistrationDialogComponent,
    WasteRegistrationComponent,
    QuestionnairePage,
    QuestionCategoryComponent,
    QuestionComponent,
    QuestionPhotosPage,
    QuestionCommentsPage,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CommonUiModule,
    MaterialModule,
    FileStoreModule,
    ImageCropperModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: MultiTranslateHttpLoaderFactory([
          { prefix: './assets/localization/', suffix: '.json' },
        ]),
        deps: [HttpBackend, Location],
      },
    }),
    UsersManagementModule.forRoot({
      authenticationUrl: environment.apiHost + 'v2/authentication',
      configurationUrl: environment.apiHost + 'v2/configuration',
    }),
    IonicStorageModule.forRoot(),
    FormsModule,
    ConfigurationModule.forRoot(environment),
    DesignSystemModule,
    LoginModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
    {
      provide: FILE_STORE_CONFIGURATION,
      useValue: {
        url: `${environment.apiHost}api/users-demo/v1.0/files`,
        allowedMimeTypes: ['image/png', 'image/jpeg', 'image/svg'],
        maxFileSize: 40 * 1024 * 1024,
      } as IFileStoreConfiguration,
    },
    {
      provide: DATE_FORMAT_CONFIGURATION,
      useValue: {
        baseFormat: 'short',
        formatOverrides: {
          short: 'dd.MM.yyyy HH:mm',
        },
      } as IDateFormatConfiguration,
    },
    {
      provide: BUTTON_STYLE_CONFIGURATION,
      useValue: {
        buttonStyles: { 'min-width': '150px' },
      } as IButtonStyleConfiguration,
    },
  ],
  bootstrap: [RootComponent],
})
export class AppModule {
  constructor(
    translateService: TranslateService,
    currentUserService: CurrentUserService,
    rest: RestService,
    auth: AuthService
  ) {
    translateService.setDefaultLang('en');

    currentUserService.user.subscribe((user) => {
      rest
        .loginAfterUserManagement(user.userName, user.id)
        .subscribe((response) => {
          if (!response) {
            auth.logoutNew();
          }
        });
    });
  }
}
